import { Stack } from '@mui/material';

import PhoneFrame from '@/designs-dev/device/PhoneFrame';
import CareHubScreen from '@/karehero-app/care/CareHubScreen';

const SITTING = '/illustrations/llama-sitting.png';

/**
 * SANDBOX. The llama on Home: sitting on a small hill in a gentle meadow
 * sunset, rising from behind the person card, with Talk to Keni beside him.
 */
const LlamaSandbox = () => (
  <Stack
    sx={{
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      py: 6,
      px: 4,
    }}
  >
    <PhoneFrame>
      <CareHubScreen grid tidy subjects solo emptyCircle mascot={SITTING} />
    </PhoneFrame>
  </Stack>
);

export default LlamaSandbox;
